import { render, staticRenderFns } from "./VueD3.vue?vue&type=template&id=ce92daea&"
import script from "./VueD3.vue?vue&type=script&lang=ts&"
export * from "./VueD3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports